import * as React from 'react';
import { useField } from 'react-final-form';
import { useTranslator, mapTags } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';
import { PUBLIC_ORGNAME } from '../../../consts';
import { useOneOrganization } from '../../../lib/useOneOrganization';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Organization() {
  const {
    __
  } = useTranslator();
  const {
    input: {
      value: sharingId
    }
    // $FlowFixMe[prop-missing]: typing error from final-form…
  } = useField('sharingId', {
    subscription: {
      value: true
    }
  });
  const {
    organization
  } = useOneOrganization(sharingId);
  let orgname = '';
  if (organization) {
    orgname = organization.name;
  } else if (sharingId === '') {
    // On creation, sharingId is at least filled with personal orga; on
    // edition, sharingId is filled with sharing_space. When sharing_space is
    // void, sharingId is filled with an empty string (cf.
    // `mapTemplateToFormData`), it means it is a public orga.
    orgname = PUBLIC_ORGNAME;
  }
  return /*#__PURE__*/_jsx(Base, {
    tagName: "p",
    marginTop: "small",
    marginBottom: "none",
    children: mapTags(__('Belongs to [[orga: %(orgname)s]]', {
      orgname
    }), ({
      orga
    }) => ({
      orga: /*#__PURE__*/_jsx(Text, {
        weight: "semibold",
        children: orga
      })
    }))
  });
}

/**
 * this prefetch is not required, it can be userful in case of edit if the
 * template org is known
 */
Organization.preFetch = (args
// $FlowFixMe[unclear-type]
) => {
  if (args.orgId) {
    // $FlowFixMe[incompatible-call] the check on orgId is juste above
    return useOneOrganization.preFetch(args);
  }
  return undefined;
};